import { render, staticRenderFns } from "./MaintenanceModePage.vue?vue&type=template&id=221996d7&scoped=true&"
import script from "./MaintenanceModePage.vue?vue&type=script&lang=ts&"
export * from "./MaintenanceModePage.vue?vue&type=script&lang=ts&"
import style0 from "./MaintenanceModePage.vue?vue&type=style&index=0&id=221996d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221996d7",
  null
  
)

export default component.exports